<div
  class="text-text-primary font-family-din isolate flex w-min min-w-80 flex-col justify-center gap-1 rounded-lg border-3 border-transparent text-center text-3xl"
>
  @for (word of words(); track $index) {
    @let w = getWord(word);
    <rid-word
      [word]="w.word"
      [rounded]="$index === 0 ? 'TOP' : $index === words().length - 1 ? 'BOTTOM' : 'NONE'"
      [appearance]="w.appearance"
      [isSelectable]="w.isSelectable"
      animate.enter="anim-fade-from-bottom"
      [style.animation-delay.ms]="delay() + 50 * $index"
      (selectionChanged)="selectionChanged.emit({ kind: $event ? 'ADDED' : 'REMOVED', index: $index })"
    />
  }
</div>
